<template>
    <div>
        <CrudIndex
            title="Project Statuses"
            :viewColumns="columns"
            fetchUrl="/project-statuses"
            createUrl="/project-statuses"
            updateRootUrl="/project-statuses"
            deleteRootUrl="/project-statuses"
            :reloadOnSuccess="true"
            :createFields="createFields"
        />
    </div>
</template>

<script>
import CrudIndex from "../../components/crud/index.vue"
import { createField, createColumn } from "../../utils/common"

export default {
    data() {
        return {
            createFields: [
                createField("Name*", "name", "text", true),
                createField("Color*", "color", "color", true),
                // createField("Status", "status", "switch", false, true),
            ],
            columns: [
                // createColumn("Id", "id", "number"),
                createColumn("Name", "name", "string"),
                createColumn("Color Hex", "color", "string"),
                // createColumn("Active", "status", "string"),
            ],
        }
    },
    components: { CrudIndex },
}
</script>

<style></style>
